module.exports = __webpack_public_path__ + "static/img/liuyonghao.e85878f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/mentorTeam/images/liuyonghao.png
// module id = 8cZs
// module chunks = 0